// Vestigium sends the dwelling and the resident as two fields, never one fused
// label. Homehealth used to fuse them — "Apt 202 (John Brookes)" — which left
// every consumer holding a string it could not take apart, so it could neither
// sort by dwelling nor lead with the person. LIAM leads with the person,
// because an alert is about someone; v-dash leads with the dwelling, because
// this is an ops view scanned by place.
//
// `name` is the dwelling. A profile has no resident when the dwelling is
// vacant, and Homehealth deliberately sends none for a closed account, so the
// resident half is always optional.
export function profileLabel(profile: any): string {
  if (!profile) return '';

  const dwelling = profile.name || '';
  const resident = profile.resident_display_name;

  return resident ? `${dwelling} (${resident})` : dwelling;
}
